import {LoanRequestStatus} from '../consts/loanStatus';

export enum CurrentTabStateTypes {
  Empty, // user has no current and no taken
  LoanRequestsOnly,
  TakenLoansOnly,
  Both, // user has both current and both taken
}

function getCurrentTabState(
  currentLoanRequests: ILoanRequestItem[],
  currentTakenLoans: ITakenLoan[],
): CurrentTabStateTypes {
  const inCompleteCurrentLoanRequests = currentLoanRequests.filter(
    loan => loan.status !== LoanRequestStatus.COMPLETED,
  );

  const completeCurrentLoanRequests = currentLoanRequests.filter(
    loan => loan.status === LoanRequestStatus.COMPLETED,
  );

  const hasLoanRequests = inCompleteCurrentLoanRequests?.length > 0;

  const hasTakenLoans =
    currentTakenLoans?.length > 0 || completeCurrentLoanRequests?.length > 0;

  if (hasLoanRequests && hasTakenLoans) {
    return CurrentTabStateTypes.Both;
  }

  if (hasLoanRequests) {
    return CurrentTabStateTypes.LoanRequestsOnly;
  }

  if (hasTakenLoans) {
    return CurrentTabStateTypes.TakenLoansOnly;
  }

  return CurrentTabStateTypes.Empty;
}

export default getCurrentTabState;
